const GLOBALS = {
  HEADLESS_COMPONENTS: {},
  FROZEN_STATE: false,
  VERSION: '0.3.1',
  ACTIVE_COMPONENTS: {},
  HTML_CACHE: {},
};

export default GLOBALS;
